<ng-container *ngIf="antwoordResultaat && antwoordResultaat.resultaat">
  <div data-hj-suppress class="ols-summary-answer" [innerHTML]="geefAntwoord()"></div>
</ng-container>
